document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelector('.jdgm-review-widget')) {
        function checkWhenLoaded() {
            let judgeMeHeader = document.querySelector('.jdgm-review-widget');
            let averageRating = document.querySelectorAll('.jdgm-rev-widg__header span.jdgm-rev-widg__summary-average');
            if(judgeMeHeader) {
                if(averageRating[0]) {
                    let text = averageRating[0].textContent;
                    let match = text.match(/(\d+\.\d+)/); // Matches a number with a decimal point

                    if (match) {
                        let rating = parseFloat(match[0]);

                        // set comma instead of dot
                        averageRating[0].textContent = rating.toFixed(1).replace('.', ',');
                        // add class loaded to averageRating
                        averageRating[0].classList.add('loaded');
                    }
                }

                let container = document.querySelector('.jdgm-row-stars--only-summary');

                if(container) {
                    // add element to container div
                    container.innerHTML += '<div class="custom-judgeme-rating"><span class="custom-judgme-rating-percentage">98%</span>of reviewers would recommend these products to a friend</div>'
                }
                clearInterval(intervalId)
            }
        }
        const intervalId = setInterval(checkWhenLoaded, 1000);

    }
})